<template>
  <div class="flex flex-col min-h-screen justify-center items-center gap-4">
    <p v-if="errorMessage" class="text-red-500 font-medium bg-red-200 px-4 py-1 rounded-md text-lg">{{errorMessage}}</p>
    <img class="h-20 mb-12" src="@/assets/img/logo-new.svg" alt="Shuttlers" />
    <spinner />
  </div>
</template>

<script>
import spinner from '@/components/Spinner.vue'
export default {
    components:{spinner},
  data() {
    return {
        errorMessage: "",
    };
  },
  methods: {
    setupUser() {
    const user = JSON.parse(this.$route.query.user);
    const decoded_user = atob(user);
     this.$store
        .dispatch("auth/setUser", JSON.parse(decoded_user))
         .then(async () => {
          const redirect = this.$route.query.redirect;
          if (redirect) {
            this.$router.push({
              path: redirect,
              query: { ...this.$route.query },
            });
          } else {
            this.$router.push({
              name: "dashboard.home",
              query: { ...this.$route.query },
            });
          }
        })
        .catch((err) => {
          if (err.response && err.response.data.message) {
            this.errorMessage = err.response.data.message;
          } else {
            this.errorMessage = "Oops! An error occurred. Please try again.";
          }
        })
    },
  },
  created(){
    this.setupUser()
  }
};
</script>
